export const getPorts = () => '/api/ports/';
export const getSchedules = () => '/api/schedules/';
export const getNearestShippings = () => '/api/schedules/nearest';
export const getAuthConfig = () => '/api/auth';
